module.exports = __webpack_public_path__ + "img/liveIcon11.428c2d29.png";